import React from "react"
import {SettingsRoutes} from "./SettingsRoutes"

export const Settings = () => (<SettingsRoutes/>)
